import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { IconComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'pu-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
})
export class FooterComponent {
  public readonly translationService = inject(I18nService);
}
